import { tss } from 'tss-react/mui';

export const useStyles = tss.create(({ theme }) => ({
  dialog: {
    '& .MuiDialog-container': {
      '& .MuiPaper-root': {
        width: '800px',
        maxHeight: '95vh',
        // overflowY: 'unset',
      },
    },
  },
  dialogTitle: {
    textAlign: 'center',
    padding: '30px 30px 20px 30px',
  },
  customizedButton: {
    position: 'absolute',
    right: '15px',
    top: '15px',
    padding: 0,
  },
  dialogContent: {
    padding: '0px 30px, 30px, 30px',
  },
  chatBox: {
    width: '100%',
    backgroundColor: theme.palette.surface.sunken,
  },
  tableV2: {
    border: `1px solid ${theme.palette.border.default}`,
    borderCollapse: 'unset',
    borderRadius: theme.shape.borderRadius,
    overflow: 'hidden',
    tableLayout: 'fixed',
    width: '100%',
  },
  table_header_cell: {
    padding: 0,
    paddingTop: '10px',
    paddingBottom: '10px',
  },
  table_header_cellV2: {
    padding: '14px 16px',
    borderBottom: `1px solid ${theme.palette.border.default}`,
    backgroundColor: theme.palette.surface.raised,
  },
  table_row_cell: {
    paddingLeft: '0px',
    paddingRight: '10px',
  },
  table_row_last_cell: {
    paddingLeft: '0px',
    paddingRight: '0px',
  },
  table_row_cellV2: {
    padding: '10px 16px',
    borderBottom: `1px solid ${theme.palette.border.subtle}`,
    width: '22%',
  },
  table_row_middle_cellV2: {
    padding: '10px 0 10px 0',
    borderBottom: `1px solid ${theme.palette.border.subtle}`,
    '& fieldset': {
      borderRadius: '10px 0px 0px 10px',
      borderRight: 'unset',
      borderColor: theme.palette.border.strong,
    },
  },
  table_row_last_cellV2: {
    padding: '10px 16px 10px 0',
    borderBottom: `1px solid ${theme.palette.border.subtle}`,
    '& fieldset': {
      borderRadius: '0px 10px 10px 0px',
      borderColor: theme.palette.border.strong,
    },
  },
  columnName: {
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '19.6px',
    color: theme.palette.text.secondary,
  },
  columnNameV2: {
    fontWeight: '500',
    fontSize: '14px',
    lineHeight: '19.6px',
    color: theme.palette.text.secondary,
  },
  call_schedule_timezone_select: {
    width: '100%',
    minHeight: '46px',
    borderRadius: '10px',
    color: theme.palette.text.primary,
    [`> svg`]: {
      marginRight: '4px',
      color: theme.palette.text.secondary,
    },
    [`& .MuiSelect-icon`]: {
      color: theme.palette.text.secondary,
    },
    [`& .MuiOutlinedInput-notchedOutline`]: {
      borderColor: theme.palette.border.strong,
    },
  },
  weekdayLabel: {
    margin: 0,
    [`& .MuiTypography-root`]: {
      fontWeight: 500,
      color: theme.palette.text.primary,
    },
  },
  weekdayLabelInactive: {
    margin: 0,
    [`& .MuiTypography-root`]: {
      fontWeight: 500,
      color: theme.palette.text.secondary,
    },
  },
  timePickerInputV2: {
    [`& .MuiInputBase-root`]: {
      height: '46px',
      backgroundColor: theme.palette.background.paper,
    },
    [`& .MuiInputAdornment-root .MuiIconButton-root`]: {
      marginRight: '2px',
      color: theme.palette.text.secondary,
    },
    [`& .MuiInputBase-root.Mui-disabled`]: {
      backgroundColor: theme.palette.surface.sunken,
      WebkitTextFillColor: theme.palette.text.disabled,
    },
    [`& .MuiInputBase-root.Mui-disabled .MuiIconButton-root`]: {
      color: theme.palette.action.disabled,
    },
  },
  timezoneLabelCell: {
    padding: '14px 16px',
    borderBottom: 'none',
    [`& .MuiTypography-root`]: {
      fontWeight: 600,
      color: theme.palette.text.primary,
    },
  },
  timezoneValueCell: {
    padding: '10px 16px 14px 0',
    borderBottom: 'none',
  },
}));
